import { Expose, Type } from 'class-transformer';
import { GetLocationResponseDto } from '../../../room/dto/response/get-location-response.dto';

export class ResourceBuildingDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'address_id' })
  addressId?: number;
  @Expose({ name: 'location_id' })
  locationId?: number;
  @Expose({ name: 'location' })
  @Type(() => GetLocationResponseDto)
  location: GetLocationResponseDto;
}
